import SlotConditionalTreeNode from '../../../../types/BotBuilder/SlotConditionalTreeNode';
import SlotValueType from '../../../../types/BotBuilder/SlotValueType';
import Slot from '../../../../types/BotBuilder/Slot';

export function createSlotConditionalsFromValues(
  values: string[]
): SlotConditionalTreeNode[] {
  const validValues = values.filter((v) => v.trim());
  return validValues.map((value) => new SlotConditionalTreeNode(value, null));
}

export function createSlotConditionalsFromSlot(
  slot: Slot
): SlotConditionalTreeNode[] {
  return slot.enumeratedSlotValues.map(
    (enumVal) => new SlotConditionalTreeNode(enumVal.resolvedValue, null)
  );
}

export function requiresSlotConditionals(
  slotType: SlotValueType | string
): boolean {
  return (
    slotType === SlotValueType.ENUMERATED_VALUE ||
    slotType === 'ENUMERATED_VALUE'
  );
}

export function mergeSlotConditionalsWithValues(
  values: string[],
  existingConditionals: SlotConditionalTreeNode[] = []
): SlotConditionalTreeNode[] {
  const validValues = values.filter((v) => v.trim());
  const result: SlotConditionalTreeNode[] = [];

  const existingMap = new Map<string, SlotConditionalTreeNode>();
  existingConditionals.forEach((conditional) => {
    if (conditional.slotValue) {
      existingMap.set(conditional.slotValue, conditional);
    }
  });

  validValues.forEach((value) => {
    const existing = existingMap.get(value);
    if (existing) {
      result.push(existing);
    } else {
      result.push(new SlotConditionalTreeNode(value, null));
    }
  });

  return result;
}
